<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <div class="spacer"></div>
        <v-row class="justify-center">
            <v-col xs="12" md="3" v-for="item in available" :key="item.title">
                <v-card width="250" height="250">
                    <v-card-title class="justify-center align-stretch">{{ item.title }}</v-card-title>
                    <v-card-text class="text-center pt-5" >{{ item.description }}</v-card-text>
                    <v-card-text class="text-center pt-5">
                        <a :href="item.link" target="_blank">{{ item.linkText || 'Скачать' }}</a>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { ReportsService } from "../../services"

    export default {
        name: "Reports",
        data() {
            return {
                metaUrl: '/reports',
                available: []
            }
        },
        methods: {
            setAvailable() {
                ReportsService.setAuth(this.$store.getters.token);
                ReportsService.getAvailable()
                    .then(res => {
                        this.available = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
        },
        created() {
            this.setAvailable();
        }
    }
</script>

<style scoped>

</style>